import axios from "axios";

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
export const API = `${BACKEND_URL}/api`;

export const api = axios.create({
  baseURL: API,
  timeout: 20000,
});

export async function submitConsultingInquiry(payload) {
  const { data } = await api.post("/consulting-inquiry", payload);
  return data;
}

export async function submitServicesInquiry(payload) {
  const { data } = await api.post("/services-inquiry", payload);
  return data;
}
